import * as React from "react";
import { Button as BaseButton } from "@/kit/ui/button";
import { FormattedMessage } from "react-intl";
import { Sliders02Icon } from "@/icons";
import { useStateContext } from "../state";
import { cn } from "@/utils/tailwind";

interface ShowOptionsButtonProps {
  className?: string;
  showAdvanced: boolean;
  setShowAdvanced: (showAdvanced: boolean) => void;
}

export const Button = ({
  className,
  showAdvanced,
  setShowAdvanced,
}: ShowOptionsButtonProps) => {
  const { inferLoading } = useStateContext();
  const [loadedOnce, setLoadedOnce] = React.useState(false);
  React.useEffect(() => {
    if (!inferLoading) {
      setLoadedOnce(true);
    }
  }, [inferLoading]);
  return (
    <BaseButton
      disabled={!loadedOnce}
      variant="secondary"
      className={cn(!loadedOnce && "invisible", className)}
      onClick={() => setShowAdvanced(!showAdvanced)}
    >
      <Sliders02Icon />
      <FormattedMessage defaultMessage="Advanced Options" />
    </BaseButton>
  );
};
